export const signJobType = {
    "SALARY": "Оплата труда",
    "CONSUMABLES": "Расходные материалы",
    "DEPRECIATION": "Обслуживание станков",
    "OTHER": "Другое",
    "TOOL": "Инструменты",
    "POWER": "Электроэнергия",
}